module.exports = __webpack_public_path__ + "img/ukey-ca.e6cc5a08.png";